module.exports = __webpack_public_path__ + "components/fullscreen-frame/icon-fullscreen-exit-7296d87ef44d5d4d4fb5348f989b2c39.svg";